import { SourceTitleKeys } from "constants/invoiceSource";
import { FileObject } from "./fileObject";
import { Group } from "./group";
import { Task } from "./task";
import { CrmSubscriptionType } from "dictionaries";

export type CardDetails = {
  brand: string;
  last_four: string;
  exp_month: number;
  exp_year: number;
  country: string;
};

export type SavedCard = {
  payment_method_id: string;
  is_default_card: boolean;
  card: CardDetails;
};

export type InvoiceTaskItem = {
  uuid: string;
  title: string;
  type: string;
  product_type: string;
};

export type AppsTypes =
  | "BOOKS"
  | "MAILROOM"
  | "TAX"
  | "SALES_TAX"
  | "OTHER"
  | "INTRA_GROUP";

export type BillingInvoice = {
  uuid: string;
  company_group: Pick<Group, "uuid" | "name">;
  amount: string;
  paid_amount: string;
  discount: string;
  invoice_number: number;
  name: string;
  short_name: string;
  season: null | string;
  created_at: string;
  paid_on: string | null;
  status: string;
  invoice_type?: "ONE_TIME" | "RECURRING" | "MONTHLY_BOOKKEEPING";
  document?: FileObject;
  document_filename?: string;
  subscription_name: string;
  task: Pick<
    Task,
    | "uuid"
    | "title"
    | "state"
    | "type"
    | "accounting_method"
    | "cash_expense"
    | "intra_group_transfers"
    | "intra_company_transfers"
    | "monthly_billable_expenses_volume"
    | "no_of_transactions"
    | "from_date"
    | "to_date"
    | "linked_invoice_paid_amount"
    | "base_task_key"
  > & {
    calculated_amount?: {
      monthly?: {
        amount: number;
        name: string;
      };

      active_subscription?: {
        amount: number;
        name: string;
      };

      monthly_plus?: {
        amount: number;
        name: string;
      };

      catchup_task?: {
        amount: number;
        name: string;
      };
    };
  };
  receipt_document?: FileObject;
  receipt_filename?: string;
  refund_data?: RefundDetails[];
  payment_card_details?: CardDetails;
  credits_used: string;
  refund_adjusted_amount: string;
  base_amount: string;
  late_fee: string;
  company_entity: {
    uuid: string;
    registered_name: string;
    formation_id: string;
    state_id: string;
    state: string;
    country: string;
    country_id: string;
    country_code: string;
  };
  spoc?: { uuid: string; name: string; email: string } | null;
  month?: number;
  expense_amount?: string;
  is_auto_pay_enabled?: boolean;
  notes?: string;
  due_date?: string;
  is_in_bank_transfer?: boolean;
  product_types: AppsTypes[];
  tasks?: InvoiceTaskItem[];
  invoice?: { uuid: string };
};

export type Receipt = {
  receipt_document: FileObject;
  receipt_filename: string;
};

export type RefundDetails = {
  uuid: string;
  amount: 12;
  reason: string;
  destination: SourceTitleKeys;
  type: string;
  card_details: CardDetails;
  refund_created_date: string;
  invoice_details: {
    invoice_id: string;
    invoice_number: number;
    invoice_amount: string;
  };
};

export type PracticeBillingType =
  | "PRACTICE_BILLING"
  | "PRACTICE_CLIENT_BILLING"
  | "NOT_SELECTED";

export type BillingInfo = { billing_email: string; invoice_emails: string[] };

export const REWARDS_PROGRAM = {
  CASH: "cash",
  POINTS: "points",
} as const;

export type BrexPoints = {
  connection:
    | {
        connection_available: true;
        balance: number;
        rate: number;
        item_id: string;
        quote_id: string;
        available_usd: number;
        rewards_program: (typeof REWARDS_PROGRAM)[keyof typeof REWARDS_PROGRAM];
      }
    | {
        connection_available: false;
        item_id: string;
        quote_id: string;
        available_usd: number;
        rewards_program: (typeof REWARDS_PROGRAM)[keyof typeof REWARDS_PROGRAM];
      }
    | null;
};
